/* Amares Homes — brand splash.
 *
 * Rules it has to obey:
 *   - never trap the visitor: a failsafe dismisses it even if `load` never fires
 *   - hold for a MINIMUM, not a fixed duration; if the page is ready sooner the
 *     remainder is still served, but a slow page isn't punished twice
 *   - once per session, not once per navigation
 *   - reduced motion gets a plain fade with no blob choreography
 *   - scroll is locked while it's up, and restored to wherever it was
 */
(function () {
  'use strict';

  var splash = document.querySelector('[data-amx-splash]');
  if (!splash) return;

  var KEY = 'amx-splash-seen';
  var EXIT_MS = 1200; // must match the CSS exit animation
  var FAILSAFE_MS = 8000;

  var minHold = parseInt(splash.dataset.amxMin, 10);
  if (isNaN(minHold)) minHold = 2400;

  var oncePerSession = splash.dataset.amxOnce === 'true';
  var skippable = splash.dataset.amxSkippable === 'true';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  var seen = false;
  try {
    seen = oncePerSession && sessionStorage.getItem(KEY) === '1';
  } catch (e) {
    // Private mode or blocked storage: just show it.
  }

  // In the theme editor, always play so it can be previewed.
  if (seen && !inEditor) {
    splash.parentNode.removeChild(splash);
    return;
  }

  document.documentElement.classList.add('amx-splash-open');

  var started = Date.now();
  var finished = false;
  var timers = [];

  function dismiss() {
    if (finished) return;
    finished = true;
    timers.forEach(clearTimeout);

    try {
      sessionStorage.setItem(KEY, '1');
    } catch (e) {
      /* not fatal */
    }

    splash.classList.add('amx-splash--exiting');

    window.setTimeout(
      function () {
        document.documentElement.classList.remove('amx-splash-open');
        splash.classList.add('amx-splash--done');
        if (splash.parentNode) splash.parentNode.removeChild(splash);
        document.dispatchEvent(new CustomEvent('amx:splash-done'));
      },
      reduce ? 320 : EXIT_MS
    );
  }

  /** Dismiss once the page is ready AND the minimum hold has elapsed. */
  function whenReady() {
    var elapsed = Date.now() - started;
    timers.push(window.setTimeout(dismiss, Math.max(0, minHold - elapsed)));
  }

  if (document.readyState === 'complete') whenReady();
  else window.addEventListener('load', whenReady, { once: true });

  // Nothing gets to hold the site hostage.
  timers.push(window.setTimeout(dismiss, FAILSAFE_MS));

  if (skippable) {
    splash.addEventListener('click', dismiss);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') dismiss();
    });
  }
})();
